var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-bubble",style:(_vm.style)},[(!_vm.image)?_c('span',[_vm._v(_vm._s(_vm.username ? _vm.username[0] : 'you'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }